/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import advSearchState from 'Stores/advSearch';
import makeApi, { URLS } from 'Utils/apiUtil';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import includeSampleCsvFile from '../../../../assets/csv/sampleIncludeExclude.csv';

const IncludeCompanyCSV = observer(props => {
  const {
    filterInPage = false,
    currentTab = 'contact',
    setShowFileView,
  } = props;
  const [fileUpload, setFileUpload] = React.useState(true);
  const [showCsvFileError, setshowCsvFileError] = React.useState('');

  const askUserToPerformSearch = (data, totalDomains) => {
    const okCallback = () => {
      const mxDataMap = {};

      if (currentTab === 'contact')
        if (filterInPage) mxDataMap.filterPlace = 'page';
        else mxDataMap.filterPlace = 'popup';
      else mxDataMap.filterPlace = 'page';
      mxDataMap.currentTab = currentTab;
      const { isFreeTrial } = userDetail;
      mxDataMap.isFreeTrial = isFreeTrial;
      mxDataMap.searchValue = data;

      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.LB_AS_INCLUDE_COMPANY_SEARCH_PERFORMED,
        mxDataMap,
      );

      if (filterInPage) advSearchState.setUploadCsv('includedDomains', data);
      else advSearchFilterPopupState.setUploadCsv('includedDomains', data);
    };
    const content = `
      Total entries in the file: <b>${totalDomains}</b> <br/>
      Number of valid domains:  <b>${data.domains.length}</b> <br/>
    `;
    confirmationPopupState.setPopupValues({
      title: 'Include Companies',
      content,
      actionBtnText: 'Ok',
      callback: okCallback,
      customClassName: 'valid-domains-popup',
    });
    confirmationPopupState.setCustomStyling({
      commonPopupIndex: 113,
      commonPopupMaskIndex: 112,
    });
    confirmationPopupState.setShowPopup(true);
  };

  const validateDomains = res => {
    const data = res;
    if (data && data.domains)
      if (data.domains.length > 0) {
        const totalDomains = data.domains.length;
        const config = {
          url: URLS.getValidDomains,
          method: 'POST',
          data: { domains: data.domains },
        };
        makeApi(config)
          .then(response => {
            if (
              response &&
              response.status === 200 &&
              response.data !== undefined
            ) {
              data.domains = response.data;
              askUserToPerformSearch(data, totalDomains);
            }
          })
          .catch(error => {
            console.log('getValidDomains error ', error);
          });
      } else {
        console.log('domians not found');
      }
  };

  const showErrorAndClear = (value = '') => {
    setshowCsvFileError(value);
    setTimeout(function() {
      setshowCsvFileError('');
    }, 4000);
  };

  const onFileChange = async e => {
    // const event = e;
    const callBack = callbackData => {
      const data = { domains: callbackData.entries, fname: callbackData.fname };
      if (!callbackData) {
        if (setShowFileView !== undefined) setShowFileView('include');
        console.log('empty file', callbackData);
        showErrorAndClear(
          'CSV file is empty, please upload a csv with domains.',
        );
      } else if (callbackData !== '' && callbackData === 'error') {
        console.log('max length error', callbackData);
        if (setShowFileView !== undefined) setShowFileView('include');
        showErrorAndClear(
          `CSV not uploaded, please upload a csv with less than ${Utils.getDomainSize()} domains.`,
        );
      } else {
        console.log('data ', callbackData);
        validateDomains(data);
      }
      setTimeout(function() {
        setFileUpload(false);
      }, 0);
      setTimeout(function() {
        setFileUpload(true);
      }, 50);
    };
    Utils.uploadCsv(e, callBack, true, Utils.getDomainSize());
  };

  const triggerUpload = e => {
    setshowCsvFileError('');
    // eslint-disable-next-line no-undef
    document.getElementById('includeCsv').click();
    if (setShowFileView !== undefined) setShowFileView('');
  };

  return fileUpload ? (
    <div className="input-section upload-csv">
      {filterInPage ? (
        <div className="upload-csv-label">
          Include Companies
          <span className="normal-text">
            {' '}
            (Upload CSV -{' '}
            <a className="sample-csv" href={includeSampleCsvFile} download="">
              Sample
            </a>
            )
          </span>
          <span
            className="csvupload-info-icon"
            title={`Supports only ${Utils.getDomainSize()} companies`}
          >
            <i className="fa fa-info-circle" />
          </span>
        </div>
      ) : (
        <div className="upload-csv-label">
          <div className="text-msg">
            Search for contacts in multiple companies by uploading list company
            names or websites.
          </div>
          <div className="">
            <span className="normal-text">
              Upload CSV -{' '}
              <a className="sample-csv" href={includeSampleCsvFile} download="">
                Sample
              </a>
            </span>
          </div>
        </div>
      )}

      <input
        id="includeCsv"
        className="custom-file-input"
        type="file"
        accept=".csv"
        onChange={onFileChange}
      />
      {showCsvFileError !== '' && (
        <span className="csv-upload-error">{showCsvFileError}</span>
      )}
      <div className="upload-btn" onClick={e => triggerUpload(e)}>
        Choose a file
      </div>
    </div>
  ) : (
    ''
  );
});

export { IncludeCompanyCSV };
export default IncludeCompanyCSV;
